import update from "immutability-helper";
import * as CreDtos from "../CRE.dtos";
var jwtDecode = require('jwt-decode'); 
import * as Config from '../configuration/consts';

var moment = require('moment');

import {
    SUBSCRIBE_SUCCESS,
    LOAD_FORUM_REQUEST,
    ACTIVE_TAG,
    EDIT_FORUM,
    CLEAR_FORUM,
    SWITCH_FORUM,
    GET_FORUM_LIST_REQUEST,
    GET_FORUM_LIST_SUCCESS,
    GET_FORUM_LIST_FAILURE,
    GET_FORUM_REQUEST,
    GET_FORUM_SUCCESS,
    GET_FORUM_FAILURE,
    SAVE_FORUM_REQUEST,
    SAVE_FORUM_SUCCESS,
    SAVE_FORUM_FAILURE,
    GET_FORUM_UPDATE_REQUEST,
    GET_FORUM_UPDATE_SUCCESS,
    GET_FORUM_UPDATE_FAILURE,
    SAVE_TAG_REQUEST,
    SAVE_TAG_SUCCESS,
    SAVE_TAG_FAILURE,
    LOAD_POST_SUCCESS,
    SAVE_POST_REQUEST,
    SAVE_POST_SUCCESS,
    SAVE_POST_FAILURE,
    ADD_REMOVE_POST_TAG_REQUEST,
    ADD_REMOVE_POST_TAG_SUCCESS,
    ADD_REMOVE_POST_TAG_FAILURE,
    SEARCH_REQUEST,
    SEARCH_SUCCESS,
    SEARCH_FAILURE,
    SEARCH_POST_REQUEST,
    SEARCH_POST_SUCCESS,
    SEARCH_POST_FAILURE,
    FOLLOW_POST_SUCCESS,
    ACTIVE_TAB
} from "../actions/forum.actions";

import {
    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
} from "../actions/login.actions";

import {
    CLEAR_USER,
    EDIT_USER,
    SAVE_MEMBER_REQUEST,
    SAVE_MEMBER_SUCCESS,
    SAVE_MEMBER_FAILURE,
    GET_MEMBER_REQUEST,
    GET_MEMBER_SUCCESS,
    GET_MEMBER_FAILURE,
    SEARCH_MEMBER_REQUEST,
    SEARCH_MEMBER_SUCCESS,
    SEARCH_MEMBER_FAILURE,
    SET_EMAIL_UPDATE_SUCCESS,
    SET_NOTIFICATION_SUCCESS,
    SET_NOTIFICATION_REQUEST,
    SET_NOTIFICATION_FAILURE,
    SET_EMAIL_UPDATE_FAILURE
} from "../actions/members.actions";

import {
    CLEAR_RESOURCE, 
    EDIT_RESOURCE,
    SAVE_RESOURCE_REQUEST,
    SAVE_RESOURCE_SUCCESS,
    SAVE_RESOURCE_FAILURE,
    SEARCH_RESOURCE_REQUEST,
    SEARCH_RESOURCE_SUCCESS,
    SEARCH_RESOURCE_FAILURE,
    ADD_REMOVE_TAG_REQUEST,
    ADD_REMOVE_TAG_SUCCESS,
    ADD_REMOVE_TAG_FAILURE,
} from "../actions/resources.actions";

const initialState = { forumLoading: true };


export default function discussionBoard(state = initialState, action) {
    switch (action.type) {
        case ACTIVE_TAB:
            return changeActiveTab(state, action);
        case SUBSCRIBE_SUCCESS:
            return subscribeForum(state, action);

        case FOLLOW_POST_SUCCESS:
            return followPost(state, action);
        case ADD_REMOVE_POST_TAG_REQUEST:
            return requestData(state, action);
        case ADD_REMOVE_POST_TAG_SUCCESS:
            return addPostTag(state, action);
        case ADD_REMOVE_POST_TAG_FAILURE:
            return logError(state, action);

            
        case ADD_REMOVE_TAG_REQUEST:
            return requestData(state, action);
        case ADD_REMOVE_TAG_SUCCESS:
            return addResourceTag(state, action);
        case ADD_REMOVE_TAG_FAILURE:
            return logError(state, action);
            

        case SAVE_FORUM_REQUEST:
            return requestData(state, action);
        case SAVE_FORUM_SUCCESS:
            return saveForum(state, action);
        case SAVE_FORUM_FAILURE:
            return logError(state, action);

        case LOAD_POST_SUCCESS:
            return setSinglePostView(loadForum(state, action), true);
        case SAVE_POST_REQUEST:
            return requestData(state, action);
        case SAVE_POST_SUCCESS:
            return savePost(state, action);
        case SAVE_POST_FAILURE:
            return logError(state, action);

        case SAVE_RESOURCE_REQUEST:
            return requestData(state, action);
        case SAVE_RESOURCE_SUCCESS:
            return saveResource(state, action);
        case SAVE_RESOURCE_FAILURE:
            return logError(state, action);

        case SAVE_MEMBER_REQUEST:
            return requestData(state, action);
        case SAVE_MEMBER_SUCCESS:
            return saveUser(state, action);
        case SAVE_MEMBER_FAILURE:
            return logError(state, action);

        case SEARCH_REQUEST:
            return requestData(state, action);
        case SEARCH_SUCCESS:
            return searchForums(state, action);
        case SEARCH_FAILURE:
            return logError(state, action);

        case SEARCH_POST_REQUEST:
            return requestData(state, action);
        case SEARCH_POST_SUCCESS:
            return savePosts(state, action);
        case SEARCH_POST_FAILURE:
            return logError(state, action);

        case SEARCH_RESOURCE_REQUEST:
            return requestData(state, action);
        case SEARCH_RESOURCE_SUCCESS:
            return searchResources(state, action);
        case SEARCH_RESOURCE_FAILURE:
            return logError(state, action);

        case GET_MEMBER_REQUEST:
            return requestData(state, action);
        case GET_MEMBER_SUCCESS:
            return getUser(state, action);
        case GET_MEMBER_FAILURE:
            return logError(state, action);

        case SEARCH_MEMBER_REQUEST:
            return requestData(state, action);
        case SEARCH_MEMBER_SUCCESS:
            return searchUsers(state, action);
        case SEARCH_MEMBER_FAILURE:
            return logError(state, action);

            
        case SET_NOTIFICATION_SUCCESS:
            return updateSetting(state, action);
        case SET_NOTIFICATION_FAILURE:
            return logError(state, action);

        case SET_EMAIL_UPDATE_SUCCESS:
            return updateEmailSetting(state, action);
        case SET_EMAIL_UPDATE_FAILURE:
            return logError(state, action);

        case SAVE_TAG_REQUEST:
            return requestData(state, action);
        case SAVE_TAG_SUCCESS:
            return saveTag(state, action);
        case SAVE_TAG_FAILURE:
            return logError(state, action);

        case GET_FORUM_REQUEST:
            return requestData(state, action);
        case GET_FORUM_SUCCESS:
            return setSinglePostView(loadForum(state, action), false);
        case GET_FORUM_FAILURE:
            return logError(state, action);

        case GET_FORUM_UPDATE_REQUEST:
            return checkingForumUpdates(state, false);
        case GET_FORUM_UPDATE_SUCCESS:
            return loadForumUpdates(state, action);
        case GET_FORUM_UPDATE_FAILURE:
            return checkingForumUpdates(state, false);

        case GET_FORUM_LIST_REQUEST:
            return requestData(state, action);
        case GET_FORUM_LIST_SUCCESS:
            return loadForums(state, action);
        case GET_FORUM_LIST_FAILURE:
            return logError(state, action);

        case LOGIN_REQUEST:
            return requestData(state, action);
        case LOGIN_SUCCESS:
            return login(state, action);
        case LOGIN_FAILURE:
            return logError(state, action);

        case LOGOUT_REQUEST:
            return requestData(state, action);
        case LOGOUT_SUCCESS:
            return logout(state, action);
        case LOGOUT_FAILURE:
            return logError(state, action);
            
        case LOAD_FORUM_REQUEST:
            return loadForum(state, action);

        case ACTIVE_TAG:
            return activeTag(state, action);

        case CLEAR_RESOURCE:
            return clearResource(state, action);
        case EDIT_RESOURCE:
            return editResource(state, action);
        case CLEAR_USER:
            return clearUser(state, action);
        case EDIT_USER:
            return editUser(state, action);
        case EDIT_FORUM:
            return editForum(state, action);
        case CLEAR_FORUM:
            return clearForum(state, action);
        case SWITCH_FORUM:
            return switchForum(state, action);
    }
    return state;
}

function updateSetting(state, action){
    return update(state, 
        {currentUser:
            { notificationImmediate:
                {$set: action.value == "1" ? true : false}
            }
        }
    );
}

function updateEmailSetting(state, action){
    return update(state, 
        {currentUser:
            { notificationFrequencyDays:
                {$set: action.value}
            }
        }
    );
}

function setSinglePostView(state, value){
    return update(state, 
        {singlePostView: 
            {$set: value}
        }
    );
}

function changeActiveTab(state, action){
    return update(state, 
        {activeTab: 
            {$set: action.tab}
        }
    );
}
function requestData(state, action){
    var newState = update(state, 
        {error: 
            {$set: undefined}
        }
    );
    if(state.forum && !state.forum.search){
        newState = update(newState, 
            {forum: 
                {search:
                    {$set: {post: undefined, resource: undefined, member: undefined }}
                }
            }
        );
    }
    if(action.type == SEARCH_POST_REQUEST){
        newState = update(newState, 
            {forum: 
                {search:
                    {post:
                    {$set: action.term}}}
            }
        );
    }
    if(action.type == SEARCH_RESOURCE_REQUEST){
        newState = update(newState, 
            {forum: 
                {search:
                    {resource:
                    {$set: action.term}}}
            }
        );
    }
    if(action.type == SEARCH_MEMBER_REQUEST){
        newState = update(newState, 
            {forum: 
                {search:
                    {member:
                    {$set: action.term}}}
            }
        );
    }

    return loadingForum(newState, true);
}

/* Sort posts to have the latest thread at the top. If there is a child with a recent comment, bump it. */
function sortPosts(forum){
    let sortedPosts = forum ? forum.posts : undefined;  
    if(sortedPosts){
        for(let i = 0; i < sortedPosts.length; i++){
                let item = sortedPosts[i];
               sortedPosts[i].maxModifiedDate = searchQuestionTree(forum, item);
        }
        sortedPosts = sortedPosts.sort((a, b) => {
            if(moment(a.maxModifiedDate).isAfter(b.maxModifiedDate)){
                return -1;
            } else if (moment(b.maxModifiedDate).isAfter(a.maxModifiedDate)) {
                return 1;
            } else {
                return 0;
            }
        });
    }
    forum.posts = sortedPosts;
    return forum;
}

function searchQuestionTree(forum, post)
{
    let childPosts = forum.posts.filter((item) => item.parentId && item.parentId === post.id);
    if(childPosts && childPosts.length > 0){
        for(let i = 0; i < childPosts.length; i++){
            let item = childPosts[i];
            let maxDate = searchQuestionTree(forum, item);
            item.maxModifiedDate = moment(maxDate).isAfter(post.modifiedDate) ? maxDate : post.modifiedDate;
            return item.maxModifiedDate;
        }
    } else {
        post.maxModifiedDate = post.modifiedDate;
        return post.maxModifiedDate;
    }
}

function logError(state, action){
    let newState = state;
    var error = {
        action: action.type,
        code: action.responseStatus.errorCode,
        message: action.responseStatus.message
    };
    // force log out if unauthorised
    if(action.responseStatus.errorCode === "401"){
        newState = logout(state, action);
        error.message = "Your login has expired. Please log in again."
    }
    
    newState = update(newState, 
        {error: 
            {$set: error}
        }
    );
    return loadingForum(newState, false);
}

function login(state, action){ 
    var decoded = jwtDecode(action.token);
    var authUser = {
        userId: action.userId,
        email: action.email,
        roles: decoded.roles,
        token: action.token
    };
    var newState = update(state, 
        {authUser: 
            {$set: authUser}
        }
    );
    
    return loadingForum(newState, false);
}


function logout(state, action) {

    var newState = update(state,
        {
            authUser:
            { $set: undefined }
        });
    newState = update(newState,
            {
                currentUser:
                { $set: undefined }
            });
    newState = update(newState,
        {
            forum:
            { $set: undefined }
        });
    newState = update(newState,
        {
            forums:
            { $set: undefined }
        });
    return loadingForum(newState, false);
}
function subscribeForum(state, action) {
    var isSubscribed = action.isSubscribed;
    var newState = update(state,
        {
            forum:
            { subscribed:
                { $set: isSubscribed }
            }
        });
   
    return newState;
}

function getUser(state, action) {
    var member = action.member;
    var newState = update(state,
        {
            currentUser:
            { $set: member }
        });
   
    return loadingForum(newState, false);
}
function switchForum(state, action) {
    let currentUser = state.currentUser;
    currentUser.type = undefined;
    var newState = update(state,
        {
            currentUser:
            { $set: currentUser }
        });
    newState = update(newState,
        {
            forum:
            { $set: undefined }
        });
    return loadingForum(newState, false);
}

function editForum(state, action){
    let forum = state.forums.find(u => u.id == action.id);
    
    var newState = update(state, 
    {editingForum: 
        {$set: forum}
    });
    return loadingForum(newState, false);
}

function clearForum(state, action){
   
    var newState = update(state, 
        {editingForum: 
            {$set: undefined}
        });
    return loadingForum(newState, false);
}

function editUser(state, action){
    let user = state.forum.members.find(u => u.email == action.userId);
    
    var newState = update(state, 
    {forum: 
        {editingUser: 
            {$set: user}
        }
    });
    return loadingForum(newState, false);
}

function clearUser(state, action){
    let user = new CreDtos.ForumMember();
    var newState = update(state, 
    {forum: 
        {editingUser: 
            {$set: user}
        }
    });
    return loadingForum(newState, false);
}

function saveUser(state, action){
    let newState = state;
    if(state.forum){
        let existingUser = state.forum.members.find(i => i.id === action.member.id);
        let index = state.forum.members.indexOf(existingUser);
        if(index >= 0){
            let obsolete = action.member.obsolete ? action.member.obsolete : false;
            if(obsolete){
                newState = update(state, 
                    {forum: 
                        {members: 
                            {$splice: [[index, 1]]}
                        }
                    });
            } else {
                newState = update(state, 
                {forum: 
                    {members: 
                        { [index]: {$set: action.member}}
                    }
                });
                
                
            }
        } else {
            newState = update(state, 
            {forum: 
                {members: 
                    {$push: [action.member]}
                }
            });
        }
        /* Clear the editing user */
        if(state.currentUser.id !== action.member.id){
            let newMember = new CreDtos.ForumMember();
            newState = update(newState, 
                {forum: 
                    {editingUser: 
                        {$set: { newMember }
                        }
                    }
                });
        }
    }
    
    // If the updated user is the same as the logged in user update the current user
    if(newState.currentUser && action.member.id == newState.currentUser.id){
        // Update local posts
        let posts = state.forum.posts.filter(i => i.forumMemberId === action.member.id);
        posts.forEach(post => {
            if(action.member.avatar){
                post.forumMemberAvatarId = action.member.avatar.id;
            }
            post.forumMemberName = `${action.member.firstName} ${action.member.lastName}`;
            newState = updatePost(newState, post);
        });

        newState = update(newState, 
                    {currentUser: 
                            {$set: action.member}
                    });
    } 
    return loadingForum(newState, false);
}

function followPost(state, action) {
    let post = state.forum.posts.find(i => i.id === action.postId);
    let index = state.forum.posts.indexOf(post);

    var newState = update(state,
        {
            forum: 
                    {posts: 
                        { [index]: {
                            subscribed: {$set: action.subscribed}}
                        }
                    }
        }); 
    return loadingForum(newState, false);
}

function savePost(state, action) {
    var post = action.post;
    
    var newState = updatePost(state, post);
    
    /* For a new post sort the posts again by date */
    var forum = sortPosts(newState.forum);
    var newState = update(newState, 
        {forum: 
            {$set: forum}
        });

    if(post.active){
        newState = setPostTreeActive(newState, post);
    }
    return loadingForum(newState, false);
}

function setPostTreeActive(state, post){
    let parentId = post.parentId;
    while (parentId){
       let parent = state.forum.posts.find(i => i.id === parentId);
        if(parent){
            parentId = parent.parentId;

            parent.active = true;
            state = updatePost(state, parent);
        } else {
            parentId = undefined;
        }
    }
    return state;
}

function updatePost(state, post){
    let newState = state;
    if (post.id) {
        let existingPost = state.forum.posts.find(i => i.id === post.id);
        let index = state.forum.posts.indexOf(existingPost);
        if (index >= 0) {
            if(post.obsolete){
                newState = update(newState,
                {
                    forum:
                    {
                        posts:
                        {
                            $splice: [[index, 1]] 
                        }
                    }
                });
            } else {
                newState = update(newState, 
                    {forum: 
                        {posts: 
                            { [index]: {$set: post}}
                        }
                    });
            }
        } else {
            newState= update(newState,
                {
                    forum:
                    {
                        posts:
                        { $push: [post] }
                    }
                });
        }
    }

    return loadingForum(newState, false);
}

function addPostTag(state, action) {
    let tag = action.tag;
    let post = state.forum.posts.find(i => i.id === action.postId);
    let index = state.forum.posts.indexOf(post);
    let newState = state;
    if (index >= 0) {
        let existingTag = undefined;
        if (post.tags) {
            existingTag = post.tags.find(t => t.id == tag.id);
        }
        if (existingTag) {
            let tagIndex = post.tags.indexOf(existingTag);
            newState = update(state,
                {
                    forum:
                    {
                        posts:
                        {
                        [index]: {
                            tags:
                            { $splice: [[tagIndex, 1]] }
                        }
                        }
                    }
                });
        } else {
            newState = update(state,
                {
                    forum:
                    {
                        posts:
                        {
                            [index]: {
                                tags:
                                { $push: [tag] }
                            }
                        }
                    }
                });
        }
    }
    return loadingForum(newState, false);
}


function addResourceTag(state, action) {
    let tag = action.tag;
    let item = state.forum.resources.find(i => i.id === action.resourceId);
    let index = state.forum.resources.indexOf(item);
    let newState = state;
    if (index >= 0) {
        let existingTag = undefined;
        if (item.tags) {
            existingTag = item.tags.find(t => t.id == tag.id);
        }
        if (existingTag) {
            let tagIndex = item.tags.indexOf(existingTag);
            newState = update(state,
                {
                    forum:
                    {
                        resources:
                        {
                        [index]: {
                            tags:
                            { $splice: [[tagIndex, 1]] }
                        }
                        }
                    }
                });
        } else {
            newState = update(state,
                {
                    forum:
                    {
                        resources:
                        {
                            [index]: {
                                tags:
                                { $push: [tag] }
                            }
                        }
                    }
                });
        }
    }
    return loadingForum(newState, false);
}

function deletePost(state, action){
    
    let post = state.forum.posts.find(p => p.id === action.postId);
    let index = state.forum.posts.indexOf(post);
    let newState = update(state, 
                {forum: 
                    {posts: 
                        {$splice: [[index, 1]]}
                    }
                });
    return loadingForum(newState, false)
}

function saveResource(state, action){
    let existingResource = state.forum.resources.find(i => i.id === action.resource.id);
    let index = state.forum.resources.indexOf(existingResource);
    let newState = undefined;
    if(index >= 0){
        let obsolete = action.resource.obsolete ? action.resource.obsolete : false;
        if(obsolete){
            newState = update(state, 
                {forum: 
                    {resources: 
                        {$splice: [[index, 1]]}
                    }
                });
        } else {
            newState = update(state, 
                {forum: 
                    {resources: 
                        { [index]: {$set: action.resource}}
                    }
                });
        }
        
    } else {

        let newResource = action.resource;

        newState = update(state, 
        {forum: 
            {resources: 
                {$push: [newResource]}
            }
        });
    }

    let newResource = new CreDtos.ForumResource(); 
    newState = update(newState, 
        {forum: 
            {editingResource: 
                {$set: { newResource }
                }
            }
        });
    return loadingForum(newState, false);
}


function saveForum(state, action){
    let existingForum = state.forums.find(i => i.id === action.forum.id);
    let index = state.forums.indexOf(existingForum);
    let newState = state;
    if(index >= 0){
        let obsolete = action.forum.obsolete ? action.forum.obsolete : false;
        if(obsolete){
            newState = update(newState, 
                {forums: 
                    {$splice: [[index, 1]]}
                });
        } else {
            newState = update(newState, 
                {forums: 
                        { [index]: {$set: action.forum}}
                });
        }
        
    } else {
        newState = update(newState, 
        {forums: 
                {$push: [action.forum]}
        });
    }

    newState = update(newState, 
        {editingForum: 
            {$set:  undefined }
        });
    return loadingForum(newState, false);
}

function editResource(state, action){
    let resource = state.forum.resources.find(u => u.id == action.resourceId);
    resource.confirmDelete = action.confirmDelete;
    var newState = update(state, 
    {forum: 
        {editingResource: 
            {$set: resource}
        }
    });
    return loadingForum(newState, false);
}

function clearResource(state, action){
    var newState = update(state, 
    {forum: 
        {editingResource: 
            {$set: undefined}
        }
    });
    return loadingForum(newState, false);
}

function saveTag(state, action){

    let existingTag = state.forum.tags.find(i => i.id === action.tag.id);
    let index = state.forum.tags.indexOf(existingTag);
    let newState = undefined;
    if (index >= 0) {
        let obsolete = action.tag.obsolete ? action.tag.obsolete : false;
        if (obsolete) {
            newState = update(state,
                {
                    forum:
                    {
                        tags:
                        { $splice: [[index, 1]] }
                    }
                });
        } else {
            newState = update(state,
                {
                    forum:
                    {
                        tags:
                        { [index]: { $set: action.tag } }
                    }
                });
        }

    } else {

        let newItem = action.tag;

        newState = update(state,
            {
                forum:
                {
                    tags:
                    { $push: [newItem] }
                }
            });
    }

    let newTag = new CreDtos.ForumTag();
    newState = update(newState,
        {
            forum:
            {
                activeTag:
                {
                    $set: { newTag }
                }
            }
        });
    return loadingForum(newState, false);
}

function activeTag(state, action) {

    var newState = state;
    let index = -1;
    if (state.forum.activeTags) {
        let existingTag = state.forum.activeTags.find(i => i.type === action.tag.type);
        index = state.forum.activeTags.indexOf(existingTag);
    } else {
        newState.forum.activeTags = [];
    }

    if (index < 0) {
        newState = update(state,
            {
                forum:
                {
                    activeTags:
                    { $push: [action.tag] }
                }
            });
    } else {
        newState = update(state,
            {
                forum:
                {
                    activeTags:
                    { [index]: { $set: action.tag } }
                }
            }); 
    }

    return loadingForum(newState, false);
}

function loadingForum(state, isLoading) {
  let newState = update(state, {
    forumLoading: { $set: isLoading }
  });
  return newState;
}

function checkingForumUpdates(state, isLoading) {
    let newState = state;
    if (state.forum) {
        newState = update(state,
            {
                forum:
                {
                    checkingUpdates:
                    { $set: isLoading }
                }
            });
    }
    return newState;
}

function loadForums(state, action){
    var newState = update(state, 
    {forums: 
        {$set: action.forums}
    });

    // Only default the forum on first load
    if (state.forums == undefined) {
        if (action.forums && action.forums.length == 1) {
            newState = update(newState,
                {
                    forum:
                    { $set: action.forums[0] }
                });
        }
    }

  return loadingForum(newState, false);
}

function loadForum(state, action){
    var forum = sortPosts(action.forum);
    forum.loaded = (action.forum.members != undefined);
    var newState = update(state, 
    {   forum: {$set: forum}
    });
  return loadingForum(newState, false);
}

function loadForumUpdates(state, action) {
    var newState = state;
    if (action.forum && action.forum.tags){
        newState = update(newState,
            {
                forum:
                { tags: { $set: action.forum.tags } }
            });
    }

    if (action.forum && action.forum.members) {
        newState = update(newState,
            {
                forum:
                { members: { $set: action.forum.members } }
            });
    }

    if (action.forum && action.forum.resources) {
    }

    if (action.forum && action.forum.posts) {
    }
    return checkingForumUpdates(newState, false);
}

function searchUsers(state, action){
    var newState = update(state, 
    {forum: 
        {members:
        { $set: action.members } }
    });
  return loadingForum(newState, false);
}

function searchResources(state, action){
    var newState = update(state, 
    {forum: 
        {resources:
        { $set: action.resources }} 
    });
  return loadingForum(newState, false);
}

function savePosts(state, action){
    var newState = update(state, 
    {forum: 
        {posts:
        { $set: action.posts } }
    });
  return loadingForum(newState, false);
}

function searchForums(state, action){
    var newState = update(state, 
    {forums: 
        { $set: action.forums } 
    });
  return loadingForum(newState, false);
}


// WEBPACK FOOTER //
// ./src/reducers/discussionBoard.ts